import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-arrow--left\"><path d=\"m4.855 9.74.96-.93L2.95 5.66h8.55V4.31H2.95l2.865-3.15-.96-.93-4.29 4.755 4.29 4.755Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol